import axios from "axios"
import { fetchOrderFail, fetchOrdersStart, fetchOrderSuccess } from "../redux/orders/orderSlice"
import { BASE_URL } from "../utils/constants"

//  no se pueden utilizar hooks fuera de componentes
export const getOrders = async (dispatch, currentUser) => {
    dispatch(fetchOrdersStart())
    try {
        const orders = await axios.get(`${BASE_URL}/orders`, {
            headers: { "x-token": currentUser.token }
        })
        if (orders) {
            dispatch(fetchOrderSuccess(orders.data.data))
        }
    } catch (error) {
        console.log(error)
        dispatch(fetchOrderFail("Upss, algo salió mal. No hay órdenes sin usuario, es como querer jugar al fútbol sin una pelota."))
    }
}

export const createOrder = async (order, dispatch, currentUser) => {
    try {
        const response = await axios.post(`${BASE_URL}/orders`, order, {
            headers: { "x-token": currentUser.token },
        })

        if (response) {
            getOrders(dispatch, currentUser)
        }
    } catch (error) {
        dispatch(fetchOrderFail("Upss, algo salió mal."))
    }
}